






import {
	defineComponent,
} from '@vue/composition-api';
import Page from '@front-app/components/layouts/Page.vue';

export default defineComponent({
	components: {
		Page,
	},
});
